// Collapsible category menu used in the collection sidebar / mobile filter drawer.
//
// Follows the ARIA disclosure pattern: each expandable item has a label <a> that
// navigates and a separate chevron <button data-category-toggle> that shows/hides
// its sub-list. Toggling is a plain click/Enter/Space on the button, so it works
// for keyboard and screen-reader users without any double-click handling.
class CategoryMenu extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const toggle = event.target.closest('[data-category-toggle]');
    if (!toggle || !this.contains(toggle)) return;

    const item = toggle.closest('.collection-categories__item');
    if (!item) return;

    const expanded = item.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };
}

if (!customElements.get('category-menu')) {
  customElements.define('category-menu', CategoryMenu);
}
